import { Component } from '@angular/core';
import { MssFieldBaseFieldTypeComponent } from '../mss-field-base.component';
import { MSS_FORMLY_IMPORTS } from '../../formly-standalone-imports';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'lib-ff-custom-radio',
  templateUrl: 'custom-radio.component.html',
  imports: [...MSS_FORMLY_IMPORTS, FormsModule, ReactiveFormsModule],
})
export class FormlyCustomRadioListComponent extends MssFieldBaseFieldTypeComponent {
  errorId?: string;

  get hasOnlyText() {
    return (this.props.options as any[]).every((x) => x.label && !x.icon);
  }
}
